var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStitcherLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 40,
    viewBox: "0 0 140 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "ml-lg-4",
    "data-v-316dc8fe": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    "data-v-316dc8fe": "",
    id: titleId
  }, "stitcherLogo") : title ? /*#__PURE__*/React.createElement("title", {
    "data-v-316dc8fe": "",
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    "data-v-316dc8fe": ""
  }, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    "data-v-316dc8fe": ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "stitcherLogo",
    transform: "translate(0.717172, 0.136364)",
    fillRule: "nonzero",
    "data-v-316dc8fe": ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    "data-v-316dc8fe": ""
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_232_",
    fill: "#EB8A23",
    x: 85.2934783,
    y: 0.192391304,
    width: 25.4277174,
    height: 15.2630435,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_231_",
    fill: "#FAC617",
    x: 56.9478261,
    y: 7.79184783,
    width: 25.4277174,
    height: 7.63152174,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_230_",
    fill: "#612368",
    x: 28.6021739,
    y: 3.59130435,
    width: 25.4277174,
    height: 11.8320652,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3792C4",
    x: 0.12826087,
    y: 11.2869565,
    width: 25.5559783,
    height: 4.13641304,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_229_",
    fill: "#C33727",
    x: 113.63913,
    y: 9.33097826,
    width: 25.5559783,
    height: 6.0923913,
    "data-v-316dc8fe": ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 44.891304)",
    "data-v-316dc8fe": ""
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_235_",
    fill: "#EB8A23",
    x: 85.2934783,
    y: 0.0641304348,
    width: 25.4277174,
    height: 8.3048913,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_234_",
    fill: "#FAC617",
    x: 56.9478261,
    y: 0.0641304348,
    width: 25.4277174,
    height: 13.8842391,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_233_",
    fill: "#612368",
    x: 28.6021739,
    y: 0.0641304348,
    width: 25.4277174,
    height: 8.3048913,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3792C4",
    x: 0.12826087,
    y: 0.0641304348,
    width: 25.5559783,
    height: 11.5434783,
    "data-v-316dc8fe": ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_228_",
    fill: "#C33727",
    x: 113.63913,
    y: 0.0641304348,
    width: 25.5559783,
    height: 4.52119565,
    "data-v-316dc8fe": ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.275,40.113587 C65.5733696,40.113587 61.9179348,36.5543478 61.9179348,30.0771739 C61.9179348,24.048913 65.8940217,20.2972826 72.275,20.2972826 C78.8804348,20.2972826 80.1951087,24.048913 80.2592391,24.2092391 L80.3233696,24.3695652 L76.2190217,26.9027174 L76.1228261,26.7103261 C76.1228261,26.6782609 74.9043478,24.7543478 72.3070652,24.7543478 C68.9402174,24.7543478 67.3048913,26.5179348 67.3048913,30.1092391 C67.3048913,33.6684783 69.0684783,35.6565217 72.3070652,35.7206522 L72.3711957,35.7206522 C74.7119565,35.7206522 76.1548913,33.7646739 76.1548913,33.7326087 L76.251087,33.5722826 L80.3233696,36.0413043 L80.2592391,36.2016304 C80.1951087,36.3298913 78.6880435,40.113587 72.275,40.113587 Z M103.025543,39.9211957 L103.025543,20.4255435 L118.352717,20.4255435 L118.352717,24.6902174 L108.284239,24.6902174 L108.284239,28.1853261 L114.37663,28.1853261 L114.37663,32.1934783 L108.284239,32.1934783 L108.284239,35.7206522 L118.352717,35.7206522 L118.352717,39.9532609 L103.025543,39.9532609 L103.025543,39.9211957 Z M95.0733696,39.9211957 L95.0733696,32.4179348 L87.6021739,32.4179348 L87.6021739,39.9211957 L82.3434783,39.9211957 L82.3434783,20.4255435 L87.6021739,20.4255435 L87.6021739,28.2173913 L95.0733696,28.2173913 L95.0733696,20.4255435 L100.332065,20.4255435 L100.332065,39.9211957 L95.0733696,39.9211957 Z M50.5347826,39.9211957 L50.5347826,24.786413 L44.8271739,24.786413 L44.8271739,20.4255435 L61.5331522,20.4255435 L61.5331522,24.786413 L55.7934783,24.786413 L55.7934783,39.9211957 L50.5347826,39.9211957 Z M36.8108696,39.9211957 L36.8108696,20.4255435 L42.0695652,20.4255435 L42.0695652,39.9211957 L36.8108696,39.9211957 Z M134.9625,33.1875 C137.207065,32.001087 138.329348,29.948913 138.329348,27.1592391 C138.329348,22.8304348 135.443478,20.4576087 130.184783,20.4576087 L121.046196,20.4576087 L121.046196,39.9532609 L126.336957,39.9532609 L126.336957,34.2456522 L129.8,34.2456522 L132.974457,39.9532609 L139.163043,39.9532609 L134.9625,33.1875 Z M130.216848,30.0130435 L126.336957,30.0130435 L126.336957,24.6902174 L130.216848,24.6902174 C132.301087,24.6902174 133.327174,25.5559783 133.327174,27.3516304 C133.327174,29.1472826 132.301087,30.0130435 130.216848,30.0130435 Z M7.63152174,40.113587 C3.1423913,40.113587 0.384782609,38.0934783 0.256521739,37.9972826 L0.12826087,37.901087 L1.6673913,33.1554348 L1.89184783,33.3798913 C1.92391304,33.4119565 4.29673913,35.6244565 7.9201087,35.6244565 C10.4853261,35.6244565 10.8059783,34.9190217 10.8059783,34.2456522 C10.8059783,32.9951087 9.13858696,32.5461957 7.21467391,32.0331522 C4.32880435,31.263587 0.7375,30.3016304 0.7375,26.1652174 C0.7375,22.3173913 3.4951087,20.201087 8.52934783,20.201087 C11.8641304,20.201087 14.9103261,21.7722826 16.0967391,24.0809783 L16.1929348,24.2413043 L12.1206522,26.8065217 L12.0244565,26.6141304 C11.2548913,25.3956522 9.81195652,24.6581522 8.24076087,24.6581522 C6.25271739,24.6581522 6.25271739,25.5559783 6.25271739,25.8445652 C6.25271739,26.9347826 7.85597826,27.3836957 9.68369565,27.8967391 C12.6336957,28.7304348 16.3211957,29.7244565 16.3211957,34.0211957 C16.3211957,37.9652174 13.563587,39.9211957 7.9201087,40.0494565 C7.82391304,40.113587 7.72771739,40.113587 7.63152174,40.113587 Z M23.0228261,39.9211957 L23.0228261,24.786413 L17.3152174,24.786413 L17.3152174,20.4255435 L34.0211957,20.4255435 L34.0211957,24.786413 L28.2815217,24.786413 L28.2815217,39.9211957 L23.0228261,39.9211957 Z",
    id: "Shape",
    fill: "#000000",
    "data-v-316dc8fe": ""
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStitcherLogo);
export default __webpack_public_path__ + "static/media/stitcher_logo.829f07ed8cdd8e0445855e1d5355866c.svg";
export { ForwardRef as ReactComponent };